/**
 * @file 登录上报
 * @author alfielv
 */

import queryString from 'query-string';
import _ from 'lodash';

import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';

const SSO_PORTAL_REFERER = 'portal_list';

export default async () => {
  try {
    const { entrance, ...restSearchParams } = queryString.parse(location.search) || {};
    if (entrance === SSO_PORTAL_REFERER) {
      await reportUserBehaviorCgi({
        data: {
          page1: '登录',
          behavior: 'sso登录',
        },
      });
      const searchParams = _.isEmpty(restSearchParams) ? '' : `?${queryString.stringify(restSearchParams)}`;
      history.replaceState(null, '', `${location.pathname}${searchParams}${location.hash}`);
      return;
    }
  } catch (error) {
    console.error(error.message);
  }
};
